<script lang="ts" setup>
import { ref, useTemplateRef } from "vue";
import date from "@/libs/date.ts";
import { onClickOutside } from "@vueuse/core";
import { useDateRange } from "@/components/DateRange/state.ts";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/vue/24/outline";

const state = useDateRange();

const emit = defineEmits(["close"]);

const props = defineProps<{ property: string }>();

const year = ref(state[props.property].year());

const container = useTemplateRef<HTMLElement>("container");

onClickOutside(container, () => emit("close"));

const onNextYear = () => year.value++;
const onPrevYear = () => year.value--;

const onResetYear = () => {
  year.value = date().year();
};

const onSelectMonth = (selectedMonth: number) => {
  const value = date().year(year.value).month(selectedMonth);

  state[props.property] = props.property === "from" ? value.startOf("month") : value.endOf("month");

  emit("close");
};
</script>

<template>
  <div ref="container" class="rounded flex flex-col -space-x-0.5 bg-white">
    <div
      class="w-full flex flex-row border-1 border-t border-r border-l border-gray-300 rounded-t-md items-center justify-between"
    >
      <button
        class="px-3 py-2 border-r border-gray-300 bg-gray-100 cursor-pointer hover:bg-gray-200"
        type="button"
        @click="onPrevYear"
      >
        <ChevronLeftIcon class="size-4"></ChevronLeftIcon>
      </button>

      <div class="w-full py-1" @dblclick="onResetYear">
        <p class="text-md font-bold text-center">{{ year }}</p>
      </div>

      <button
        class="px-3 py-2 border-l border-gray-300 bg-gray-100 cursor-pointer hover:bg-gray-200"
        type="button"
        @click="onNextYear"
      >
        <ChevronRightIcon class="size-4"></ChevronRightIcon>
      </button>
    </div>

    <div
      class="w-full grid grid-cols-3 border-1 border-l border-b border-r border-gray-300 rounded-b"
    >
      <button
        class="p-3 cursor-pointer border-r border-b border-gray-300 hover:bg-gray-50"
        type="button"
        @click="onSelectMonth(0)"
      >
        Jan
      </button>
      <button
        class="p-3 cursor-pointer border-r border-b border-gray-300 hover:bg-gray-50"
        type="button"
        @click="onSelectMonth(1)"
      >
        Feb
      </button>
      <button
        class="p-3 cursor-pointer border-b border-gray-300 hover:bg-gray-50"
        type="button"
        @click="onSelectMonth(2)"
      >
        Mrt
      </button>
      <button
        class="p-3 cursor-pointer border-r border-b border-gray-300 hover:bg-gray-50"
        type="button"
        @click="onSelectMonth(3)"
      >
        Apr
      </button>
      <button
        class="p-3 cursor-pointer border-r border-b border-gray-300 hover:bg-gray-50"
        type="button"
        @click="onSelectMonth(4)"
      >
        Mei
      </button>
      <button
        class="p-3 cursor-pointer border-b border-gray-300 hover:bg-gray-50"
        type="button"
        @click="onSelectMonth(5)"
      >
        Jun
      </button>
      <button
        class="p-3 cursor-pointer border-r border-b border-gray-300 hover:bg-gray-50"
        type="button"
        @click="onSelectMonth(6)"
      >
        Jul
      </button>
      <button
        class="p-3 cursor-pointer border-r border-b border-gray-300 hover:bg-gray-50"
        type="button"
        @click="onSelectMonth(7)"
      >
        Aug
      </button>
      <button
        class="p-3 cursor-pointer border-b border-gray-300 hover:bg-gray-50"
        type="button"
        @click="onSelectMonth(8)"
      >
        Sep
      </button>
      <button
        class="p-3 cursor-pointer border-r border-gray-300 hover:bg-gray-50"
        type="button"
        @click="onSelectMonth(9)"
      >
        Okt
      </button>
      <button
        class="p-3 cursor-pointer border-r border-gray-300 hover:bg-gray-50"
        type="button"
        @click="onSelectMonth(10)"
      >
        Nov
      </button>
      <button class="p-3 cursor-pointer hover:bg-gray-50" type="button" @click="onSelectMonth(11)">
        Dec
      </button>
    </div>
  </div>
</template>

<style scoped></style>
